import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

const CheckBoxComponent = forwardRef(
  (
    {
      name,
      value,
      checked = false,
      onChange,
      label = "",
      className = "",
      disabled = false,
      style = {},
      ...rest
    },
    ref
  ) => {
    return (
      <div className="checkBox" key={`default-checkbox-${name}-${value}`}>
        <Form.Check // prettier-ignore
          type={"checkbox"}
          id={`default-checkbox-${name}-${value}`}
          label={label}
          name={name}
          value={value}
          className="m-0"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          {...rest}
        />
      </div>
    );
  }
);

CheckBoxComponent.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
};

export default CheckBoxComponent;
